export default {"src":"/_next/static/media/photography.5b6aee43.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};